import { COLOURS } from '../../../../../pp2/theme';
export var labelContainerCss = {
  display: 'grid',
  gridAutoColumns: 'column',
  gridTemplateColumns: ' auto 1fr',
  gap: '10px',
  '.tqc-form__label': {
    display: 'inline'
  },
  '.label__required-indicator': {
    color: COLOURS.red[700]
  },
  '.label__required-text': {
    color: COLOURS.black,
    fontWeight: '400'
  }
};